<ng-container *transloco="let t; read:'permit.details.checkpointsModal'">
    <div class="modal">
        <div class="modal__content">
            <pmt-permit-checkpoints [permitId]="data.permitId"></pmt-permit-checkpoints>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("close") }}</button>
        </div>
    </div>
</ng-container>
